import { googleMapsMapping } from '../google-json-structure.js';

// https://nominatim.openstreetmap.org/reverse?lat=52.06557&lon=5.11382&zoom=18&format=jsonv2
const openstreetmaps = {
	[ googleMapsMapping.address ]: { apiName: 'display_name' },
	[ googleMapsMapping.lat ]: {
		apiName: 'lat',
		parser: ( obj ) => ( obj.lat ? parseFloat( obj.lat ) : null ),
	},
	[ googleMapsMapping.lng ]: {
		apiName: 'lon',
		parser: ( obj ) => ( obj.lon ? parseFloat( obj.lon ) : null ),
	},
	[ googleMapsMapping.zoom ]: { apiName: null, parser: () => 14 },
	[ googleMapsMapping.place_id ]: { apiName: 'osm_id' },
	[ googleMapsMapping.name ]: { apiName: 'name' },
	[ googleMapsMapping.street_number ]: { apiName: 'house_number' },
	[ googleMapsMapping.street_name ]: { apiName: 'road' },
	[ googleMapsMapping.city ]: { apiName: 'city' },
	[ googleMapsMapping.state ]: { apiName: 'state' },
	[ googleMapsMapping.state_short ]: { apiName: 'state_code' },
	[ googleMapsMapping.post_code ]: { apiName: 'postcode' },
	[ googleMapsMapping.country ]: { apiName: 'country' },
	[ googleMapsMapping.country_short ]: { apiName: 'country_code' },
};

export default openstreetmaps;
